import { FC } from 'react';
import './PartnersAboutComponent.scss';
import { PARTNERS_ABOUT_LABELS } from './model';

const PartnersAboutComponent: FC = () => {
	return (
		<div className='partners-about-container'>
			<h1 className='section-title'>{PARTNERS_ABOUT_LABELS.title}</h1>
			<div className='partner-item'>
				<img className='partner-image image-1' src={PARTNERS_ABOUT_LABELS.partner1.image} alt='' />
				<div className='partner-content-container'>
					<h2 className='section-subtitle'>
						<a
							href={PARTNERS_ABOUT_LABELS.partner1.titleLinkContent}
							target='_blank'
							rel='noopener noreferrer'
						>
							{PARTNERS_ABOUT_LABELS.partner1.titleLinkLabel}
						</a>
					</h2>
					<p className='section-content'>
						{PARTNERS_ABOUT_LABELS.partner1.content}
						<a
							href={PARTNERS_ABOUT_LABELS.partner1.contentLinkContent}
							target='_blank'
							rel='noopener noreferrer'
						>
							{PARTNERS_ABOUT_LABELS.partner1.contentLinkLabel}
						</a>
						.
					</p>
				</div>
			</div>
			<div className='partner-item'>
				<img className='partner-image image-2' src={PARTNERS_ABOUT_LABELS.partner2.image} alt='' />
				<div className='partner-content-container'>
					<h2 className='section-subtitle'>
						<a
							href={PARTNERS_ABOUT_LABELS.partner2.titleLinkContent}
							target='_blank'
							rel='noopener noreferrer'
						>
							{PARTNERS_ABOUT_LABELS.partner2.titleLinkLabel}
						</a>
					</h2>
					<p className='section-content'>{PARTNERS_ABOUT_LABELS.partner2.content}</p>
				</div>
			</div>
			<div className='partner-item'>
				<img className='partner-image image-3' src={PARTNERS_ABOUT_LABELS.partner3.image} alt='' />
				<div className='partner-content-container'>
					<h2 className='section-subtitle'>
						<a
							href={PARTNERS_ABOUT_LABELS.partner3.titleLinkContent}
							target='_blank'
							rel='noopener noreferrer'
						>
							{PARTNERS_ABOUT_LABELS.partner3.titleLinkLabel}
						</a>
					</h2>
					<p className='section-content'>{PARTNERS_ABOUT_LABELS.partner3.content}</p>
				</div>
			</div>
		</div>
	);
};

export default PartnersAboutComponent;
